export enum ReportsListMode {
  ALL = 'all',
  IN_PROGRESS = 'inprogress',
  FINALIZED = 'finalized',
  ECI = 'eci'
}
